import { publish } from '../../pubsub';
import useContainerProps from '../helpers/useContainerProps';

/**
 * Fire when user change origin in any component
 * @param {Object} container
 * @param {String} originAirportIataCode
 * @param {String} cardType
 *
 */
export default (container, originAirportIataCode, cardType = 'fare') => {
  const { eventType } = useContainerProps(container);
  publish(`em.${cardType}.${eventType}.origin`, {
    originAirportIataCode
  });
};
